import { put, takeEvery } from "redux-saga/effects";
import { SlideComment, SlideCommentChangeSet } from "../../models/SlideComment";
import { TempFile, FilePreviewImage, Slide } from "../../models/slides";
import { ErrorResponse } from "../../models/store";
import {
    CreateTempFile,
    CreateTempFileComplete,
    GetTempPageCount,
    GetTempPageCountComplete,
    GetTempPreviewUrl,
    GetTempPreviewUrlComplete,
    CreateNewSlide,
    CreateNewSlideComplete,
    DeleteTempFile,
    DeleteTempFileComplete,
    GetSlideById,
    GetSlideByIdComplete,
    GetSlidePageCount,
    GetSlidePageCountComplete,
    GetSlidePreviewImageUrl,
    GetSlidePreviewImageUrlComplete,
    EditSlide,
    EditSlideComplete,
    // EditSlideFailed,
    DeleteSlide,
    DeleteSlideComplete,
    DeleteSlideFailed,
    AddSlideComment,
    AddSlideCommentComplete,
    UpdateSlideCommentComplete,
    DeleteSlideCommentComplete,
    DeleteSlideComment,
} from "../actions/SlideActions";
import SlideApi from "../apis/SlideApi";
import SlideEvent from "../events/SlideEvent";

// コンテンツアップロードでURL生成
function* CreateTampFileWorker({ file }: ReturnType<typeof CreateTempFile>) {
    const tempFile: TempFile = yield SlideApi.createTempFile(file);
    yield put(CreateTempFileComplete(tempFile));
}

// tempファイルのページ総数の取得
function* GetTempPageCountWorker({ keyName }: ReturnType<typeof GetTempPageCount>) {
    const pageCount: number = yield SlideApi.getTempPageCount(keyName);
    yield put(GetTempPageCountComplete(pageCount));
}

// tempファイル表示URLの取得
function* GetTempPreviewUrlWorker({ keyName, pageNo }: ReturnType<typeof GetTempPreviewUrl>) {
    const response: FilePreviewImage = yield SlideApi.getTempPreviewUrl(keyName, pageNo);
    yield put(GetTempPreviewUrlComplete(response));
}

// 新規コンテンツ作成
function* CreateNewSlideWorker({ newSlide }: ReturnType<typeof CreateNewSlide>) {
    yield SlideApi.createNewSlide(newSlide);
    yield put(CreateNewSlideComplete());
}

//コンテンツコメント作成
function* AddSlideCommentWorker({ slideCommentChangeSet }: ReturnType<typeof AddSlideComment>) {
    const savedComment: SlideComment = yield SlideApi.createSlideComment(slideCommentChangeSet);
    yield put(AddSlideCommentComplete(savedComment));
}

// コメントの編集
function* UpdateSlideCommentWorker({ slideCommentChangeSet }: ReturnType<typeof AddSlideComment>) {
    const savedComment: SlideCommentChangeSet = yield SlideApi.updateSlideComment(
        slideCommentChangeSet
    );
    yield put(UpdateSlideCommentComplete(slideCommentChangeSet.documentId, savedComment));
}

// コメントの削除
function* DeleteSlideCommentWorker({
    id,
    userId,
    documentId,
}: ReturnType<typeof DeleteSlideComment>) {
    const savedComment: SlideCommentChangeSet = yield SlideApi.deleteSlideComment(
        id,
        userId,
        documentId
    );
    yield put(DeleteSlideCommentComplete(documentId, savedComment));
}

// // コメントの返信
// function* replayVideoCommentWorker({
//     slideCommentChangeSet,
// }: ReturnType<typeof addVideoComment>) {
//     const savedComment: VideoComment = yield VideoApi.replayToVideoComment(slideCommentChangeSet);
//     yield put(replayToVideoCommentComplete(savedComment));
// }

// 新規コンテンツ作成キャンセルでtempファイルの削除
function* DeleteTempFileWorker({ keyName }: ReturnType<typeof DeleteTempFile>) {
    yield SlideApi.deleteTempFile(keyName);
    yield put(DeleteTempFileComplete(keyName));
}

// コンテンツ情報取得
function* GetSlideByIdWorker({ userId, id }: ReturnType<typeof GetSlideById>) {
    const response: Slide = yield SlideApi.getSlideById(userId, id);
    yield put(GetSlideByIdComplete(response));
}

// コンテンツページ総数の取得
function* GetSlidePageCountWoker({ id, fileName }: ReturnType<typeof GetSlidePageCount>) {
    const pageCount: number = yield SlideApi.getSlidePageCount(id, fileName);
    yield put(GetSlidePageCountComplete(pageCount));
}

// コンテンツ表示URLの取得
function* GetSlidePreviewImageUrlWoker({
    id,
    fileName,
    pageNo,
}: ReturnType<typeof GetSlidePreviewImageUrl>) {
    const previewUrl: FilePreviewImage = yield SlideApi.getSlidePreviewImageUrl(
        id,
        fileName,
        pageNo
    );
    yield put(GetSlidePreviewImageUrlComplete(previewUrl));
}

// コンテンツ編集
function* EditSlideWoker({ editSlideInfo }: ReturnType<typeof EditSlide>) {
    let updateSlide: Slide = yield SlideApi.editSlide(editSlideInfo);

    //添付資料APIコール
    if (updateSlide) {
        if (editSlideInfo.documentName.length > 0 || editSlideInfo.materialId.length > 0) {
            const uploadDocument: Slide = yield SlideApi.UploadDocument({
                userId: editSlideInfo.userId,
                slideStockId: editSlideInfo.content.id,
                materialId: editSlideInfo.materialId,
                documentFile: editSlideInfo.documentFile,
                documentName: editSlideInfo.documentName,
            });

            // 資料リストを更新
            if (uploadDocument) {
                updateSlide = {
                    ...updateSlide,
                    extraMaterials: uploadDocument.extraMaterials,
                };
            }
        }
    }

    yield put(EditSlideComplete(updateSlide));
}

// コンテンツの削除
function* DeleteSlideWorker({ id }: ReturnType<typeof DeleteSlide>) {
    const response: string | ErrorResponse = yield SlideApi.deleteSlide(id);
    if (response instanceof ErrorResponse) {
        if (!response || (response && response.response.status !== 200)) {
            yield put(DeleteSlideFailed());
        }
    } else {
        yield put(DeleteSlideComplete(id));
    }
}

export default function* ExVideoSaga() {
    yield takeEvery(SlideEvent.CreateTempFileStarted, CreateTampFileWorker);
    yield takeEvery(SlideEvent.GetTempPageCountStarted, GetTempPageCountWorker);
    yield takeEvery(SlideEvent.GetTempPreviewUrlStarted, GetTempPreviewUrlWorker);
    yield takeEvery(SlideEvent.CreateNewSlideStarted, CreateNewSlideWorker);
    yield takeEvery(SlideEvent.AddSlideCommentStarted, AddSlideCommentWorker);
    yield takeEvery(SlideEvent.UpdateSlideCommentStarted, UpdateSlideCommentWorker);
    yield takeEvery(SlideEvent.DeleteSlideCommentStarted, DeleteSlideCommentWorker);
    // yield takeEvery(SlideEvent.ReplayToSlideStarted, ReplaySlideCommentWorker);
    yield takeEvery(SlideEvent.DeleteTempFileStarted, DeleteTempFileWorker);
    yield takeEvery(SlideEvent.GetSlideByIdStarted, GetSlideByIdWorker);
    yield takeEvery(SlideEvent.GetSlidePageCountStarted, GetSlidePageCountWoker);
    yield takeEvery(SlideEvent.GetSlidePreviewImageUrlStarted, GetSlidePreviewImageUrlWoker);
    yield takeEvery(SlideEvent.EditSlideStarted, EditSlideWoker);
    yield takeEvery(SlideEvent.DeleteSlideStarted, DeleteSlideWorker);
}
